var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9581 14.9473H21.7927C22.0134 15.5516 22.134 16.2037 22.134 16.8834V25.0674C22.134 25.3508 22.0847 25.6228 21.995 25.8758H25.5749C26.9121 25.8758 28 24.7879 28 23.4506V18.9892C28.0001 16.7605 26.1869 14.9473 23.9581 14.9473Z",
    fill: "#D96122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86607 16.8834C5.86607 16.2037 5.98665 15.5516 6.20737 14.9473H4.04196C1.81322 14.9473 0 16.7605 0 18.9892V23.4507C0 24.7879 1.0879 25.8759 2.42518 25.8759H6.00514C5.91539 25.6228 5.86607 25.3508 5.86607 25.0674V16.8834Z",
    fill: "#D96122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4753 12.8414H11.5249C9.29613 12.8414 7.48291 14.6547 7.48291 16.8834V25.0674C7.48291 25.5138 7.84483 25.8758 8.2913 25.8758H19.7089C20.1553 25.8758 20.5173 25.5139 20.5173 25.0674V16.8834C20.5173 14.6547 18.704 12.8414 16.4753 12.8414Z",
    fill: "#D96122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 2.12402C11.3198 2.12402 9.13916 4.30464 9.13916 6.98504C9.13916 8.80313 10.1426 10.391 11.6245 11.2246C12.3274 11.62 13.1378 11.846 14.0001 11.846C14.8624 11.846 15.6728 11.62 16.3757 11.2246C17.8577 10.391 18.8611 8.80308 18.8611 6.98504C18.8611 4.30469 16.6805 2.12402 14.0001 2.12402Z",
    fill: "#D96122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46422 6.65491C3.45964 6.65491 1.82886 8.28569 1.82886 10.2903C1.82886 12.2948 3.45964 13.9256 5.46422 13.9256C5.9727 13.9256 6.45691 13.8203 6.89676 13.631C7.65724 13.3036 8.28429 12.724 8.6723 11.998C8.94464 11.4885 9.09958 10.9072 9.09958 10.2903C9.09958 8.28575 7.46879 6.65491 5.46422 6.65491Z",
    fill: "#D96122"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5357 6.65491C20.5312 6.65491 18.9004 8.28569 18.9004 10.2903C18.9004 10.9073 19.0553 11.4885 19.3277 11.998C19.7157 12.724 20.3427 13.3036 21.1032 13.631C21.5431 13.8203 22.0273 13.9256 22.5357 13.9256C24.5403 13.9256 26.1711 12.2948 26.1711 10.2903C26.1711 8.28569 24.5403 6.65491 22.5357 6.65491Z",
    fill: "#D96122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderGroup);
export default __webpack_public_path__ + "static/media/header-group.e4ab855a2355db57ccd05d7340011a8d.svg";
export { ForwardRef as ReactComponent };